import { GetListResponse, instance } from "libs/api";

import { ProductComment } from "../../product.types";
import { ApiRoutesProducts } from "./../../constants/enums";
import { GetProductCommentsRequestParams } from "./getProductComments.types";

export const requestGetProductComments = async (
  params: GetProductCommentsRequestParams
): Promise<GetListResponse<ProductComment>> => {
  return await instance.get(ApiRoutesProducts.ProductComments, {
    params
  });
};
